export const BUTTON = {
  panic: 'panic',
  events: 'events',
  armHomeMode: 'arm_home_mode',
  arm: 'arm',
  disarm: 'disarm',
}
